"use client";
import React from "react";
import Image from "next/image";
import styles from "./competencies.module.css";
import scrollStyles from "./competenciesScroll.module.css";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export type CoreCompetenciesProps = {
  subtitle?: string;
  title?: string;
  items?: string[];
  imageUrl?: string;
};

const fallbackItems = [
  "Agile Methodologies",
  "User Experience and Interface Design",
  "Web and Mobile Application Development",
  "Product and Software Engineering Management",
  "Artificial Intelligence and Machine Learning",
  "DevOps and Site Reliability Engineering",
];

const CoreCompetencies: React.FC<CoreCompetenciesProps> = ({
  subtitle = "Core competencies",
  title = "Where Expertise Meets Innovation",
  items = fallbackItems,
  imageUrl = "/images/core-comp.svg",
}) => {
  const [sectionRef, isVisible] = useScrollAnimation();

  return (
    <section
      ref={sectionRef as React.RefObject<HTMLElement>}
      className={`w-full text-slate-300 ${styles.sectionBackgroundColor} ${isVisible ? scrollStyles.sectionAnimation : ""}`}
    >
      <div
        className={`mx-auto max-w-7xl py-24 px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6`}
      >
        <div className={`col-span-1 my-auto ${isVisible ? scrollStyles.contentAnimation : ""}`}>
          <p
            className={`text-xl leading-7 font-semibold mb-3 ${styles.competenciesTitle}`}
          >
            {subtitle}
          </p>
          <h2 className={`font-assistant text-5xl text-slate-200 mb-6`}>
            {title}
          </h2>
          <ul className={`list-disc ml-6 space-y-2`}>
            {items.map((item, idx) => (
              <li key={`${item}-${idx}`}>{item}</li>
            ))}
          </ul>
        </div>
        <div className={`col-span-1 hidden md:block ${isVisible ? scrollStyles.imageAnimation : ""}`}>
          <Image
            src={imageUrl}
            alt={`skills joining forces`}
            height={439}
            width={583}
          />
        </div>
      </div>
    </section>
  );
};

export default CoreCompetencies;
